export const manifest = {
  screens: {
    scr_1lcrey: { name: "Landing (Sales Page)", route: "/", position: {"x":160,"y":220} },
    scr_zj3lx9: { name: "Checkout", route: "/checkout", position: {"x":1560,"y":220} },
    scr_3q2txt: { name: "Confirmación", route: "/checkout", state: {"step":"success"}, position: {"x":2960,"y":220} },
  },
  sections: {
    sec_f8lxxm: { name: "Checkout flow", x: 0, y: 0, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_f8lxxm", children: [
      { kind: "screen", id: "scr_1lcrey" },
      { kind: "screen", id: "scr_zj3lx9" },
      { kind: "screen", id: "scr_3q2txt" },
    ] },
  ],
}
